import { call, put, takeLatest } from 'redux-saga/effects';
import { authService } from './collections.service';
import {
  COLLECT_LOAD,
  COLLECT_RESERVE,
  GET_COLLECTION_HISTORY, GET_COLLECTION_HISTORY_SUCCESS,
  GET_COLLECTIONS,
  GET_COLLECTIONS_SUCCESS,
} from './collections.types';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { toast } from 'react-toastify';
import { ToastScreen } from '../../components';

/** Collections */

function* getCollections(action) {
  if (action?.payload?.load !== 'noLoad'){
     yield put(httpRequestsOnLoadActions.appendLoading(action.type));
  }
  yield put(httpRequestsOnErrorsActions.removeError(action.type));
  try {
    const res = yield call(authService.getCollectionsService, action.payload.params);
    yield put({
      type: GET_COLLECTIONS_SUCCESS,
      payload: res.data,
    });
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    yield put(httpRequestsOnErrorsActions.appendError(action.type, err.data.message));
  }
}
function* getCollectionHistory(action) {
  if (action?.payload?.load !== 'noLoad'){
     yield put(httpRequestsOnLoadActions.appendLoading(action.type));
  }
  yield put(httpRequestsOnErrorsActions.removeError(action.type));
  try {
    const res = yield call(authService.getCollectionHistoryService, action.payload.params);
    yield put({
      type: GET_COLLECTION_HISTORY_SUCCESS,
      payload: res.data,
    });
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    yield put(httpRequestsOnErrorsActions.appendError(action.type, err.data.message));
  }
}

function* collectReserve(action) {
  yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
  // yield put(httpRequestsOnErrorsActions.removeError(action.type));
  yield put(httpRequestsOnLoadActions.appendLoading(action.type));
  try {
    yield call(authService.collectReserveService, action?.payload?.carrierId, action.payload.params);
    yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    toast(<ToastScreen type={'error'} text={err?.data?.message} />);
    // yield put(httpRequestsOnErrorsActions.appendError(action.type, err.data.message));
  }
}
function* collectLoad(action) {
  yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
  // yield put(httpRequestsOnErrorsActions.removeError(action.type));
  yield put(httpRequestsOnLoadActions.appendLoading(action.type));
  try {
    yield call(authService.collectLoadService, action?.payload?.carrierId, action.payload.params);
    yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    toast(<ToastScreen type={'error'} text={err?.data?.message} />);
    // yield put(httpRequestsOnErrorsActions.appendError(action.type, err.data.message));
  }
}

/** End */


export const watchCollection = function* watchCollectionSaga() {
  /** Collections */
  yield takeLatest(GET_COLLECTIONS, getCollections);
  yield takeLatest(GET_COLLECTION_HISTORY, getCollectionHistory);
  yield takeLatest(COLLECT_RESERVE, collectReserve);
  yield takeLatest(COLLECT_LOAD, collectLoad);
  /** End */
};
